import { useContext, useEffect, useRef, useState } from 'react'

import { Button } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import { FormContext } from 'Components/Hooks/ContextForm'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import InputsWithValidate from 'Components/UI/Molecules/InputsWithValidate'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { QuotationFields } from 'Components/UI/Molecules/Vehicles/SearchVehicles/DialogVehicle/Content/Tabs/Content/Quotation/Modals/Fields'
import { formNew } from 'Components/Validation/Vehicles/SearchVehicles'
import { format, isValid } from 'date-fns'
import { Form, Formik } from 'formik'
import { useSnackbar } from 'notistack'
import { interfaces } from 'service/interfaces'

import useStyles from '../../../../../../../StyleModalNew'

const New = (props) => {
  const { formEdit } = useContext(FormContext)
  const { handleCloseMain } = props
  const { enqueueSnackbar } = useSnackbar()
  const id = formEdit.vehicle.id

  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const formSubmitRef = useRef(null)

  const handleSubmit = () => {
    formSubmitRef.current.click()
  }

  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  const formatDateForBackend = (value) => {
    if (!value) return null
    if (!(value instanceof Date) || !isValid(value)) return null
    return format(value, 'yyyy-MM-dd')
  }

  const onSubmit = (values) => {
    const payload = {
      ...values,
      proveedor: values.proveedor || values.proveedor_manual,
      fecha_factura: formatDateForBackend(values.fecha_factura),
      fecha_pago: formatDateForBackend(values.fecha_pago),
    }

    delete payload.proveedor_manual

    interfaces.vehicleInterface
      .newPayment(id, payload)
      .then((res) => {
        enqueueSnackbar(res.data, { variant: 'success' })
        handleCloseMain()
      })
      .catch(() => {
        enqueueSnackbar('Algo salió mal!', { variant: 'error' })
      })
  }

  const [vehicles, setVehicles] = useState([])
  const [companies, setCompanies] = useState([])
  const [types, setTypes] = useState([])

  async function getVehiclesForPayment() {
    await interfaces.vehicleInterface.getAllVehicleForPayments().then((res) => {
      setVehicles(res.data)
    })
  }

  async function getData() {
    await interfaces.vehicleInterface.getCompanies().then((res) => {
      setCompanies(res.data)
    })
    await interfaces.conceptsInterface.getConcepts().then((res) => {
      setTypes(res.data)
    })
  }

  useEffect(() => {
    getData()
  }, [])

  const children = () => {
    return (
      <Formik
        onSubmit={onSubmit}
        initialValues={{
          proveedor: '',
          proveedor_manual: '',
          fecha_factura: null,
          fecha_pago: null,
          suc_factura: '',
          nro_factura: '',
          monto_total: '',
          observaciones: '',
          tipo: '',
          //vehiculos: [],
        }}
        validationSchema={formNew}
      >
        {({ setFieldValue, isSubmitting, values }) => (
          <Form>
            <InputsWithValidate
              fields={QuotationFields(
                companies,
                types,
                vehicles,
                setFieldValue,
                values,
                getVehiclesForPayment
              )}
              spacing={2}
              setFieldValue={setFieldValue}
              isSubmitting={isSubmitting}
              strictManualDate={true}
            />

            <button style={{ display: 'none' }} type="submit" ref={formSubmitRef} />
          </Form>
        )}
      </Formik>
    )
  }

  return (
    <div>
      <Button
        className={classes.textTransformLetter}
        variant="contained"
        color="primary"
        type="submit"
        startIcon={<AddIcon />}
        onClick={handleOpen}
      >
        Nuevo
      </Button>
      <DialogComponent
        customHeight="auto"
        widthLarge="30vw"
        tipo="center"
        open={open}
        disableBackdropClick={true}
        handleclose={handleClose}
        title="Nuevo costo/gasto"
        children={children()}
        actions={
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'flex-end',
              marginRight: '2px',
            }}
          >
            <CancelConfirmButtons
              onClickCancel={handleClose}
              onClickSubmit={handleSubmit}
              submitText="Guardar"
            />
          </div>
        }
      />
    </div>
  )
}

export default New
